import { Component, OnInit } from '@angular/core';
import { StingrayAuthenticationService } from '@app/core/authentication/stingray-authentication.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'unite-callback',
    templateUrl: './callback.component.html',
    styleUrls: ['./callback.component.scss'],
    imports: [MatProgressSpinner, TranslateModule]
})
export class CallbackComponent implements OnInit {

  constructor(private stingrayAuthenticationService: StingrayAuthenticationService) {
  }

  ngOnInit(): void {
    this.stingrayAuthenticationService.handleAuthCallback();
  }
}
